// extracted by mini-css-extract-plugin
export default {"root-header":"Table_root-header__At5XD","root-row":"Table_root-row__B-Cgw","nowcasting-info":"Table_nowcasting-info__VTD1B","title":"Table_title__h2s4e"};